<template>
    <div>
        <HeaderBreadcrumbs
            :items="[
                { label: 'Requested Content' },
            ]"
            title="All Requested Content"
        />
        <div class="bg-white p-4 my-3 rounded-lg shadow-sm">
            <div class="flex justify-between items-center  align-middle mb-4">
                <div class="block relative">
                    <input class="bg-gray-100 rounded-lg py-2 px-4 border w-96"
                        placeholder='Search User Email, Content Title, Author' v-model="filter" @input="filterRequestContent" />
                    <button v-if="filter"
                        class="absolute top-1/2 right-5 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                        @click="actionReset" title="Clear search">
                        ✕
                    </button>
                    <svg v-if="!filter" class="w-6 h-6 text-gray-500 dark:text-white absolute top-1.5 right-3"
                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                        viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
                            d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />
                    </svg>
                </div>
                <div class="button_donwload flex">
                    <button class="bg-white rounded-lg px-4 mr-4 py-2 text-gray-700 border flex justify-between "
                        @click="btndownloadCSV" :class="{ 'opacity-50 pointer-events-none': item.length === 0 }">
                        <svg class="w-5 h-5 mr-2 text-gray-800 dark:text-white" aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                            viewBox="0 0 24 24">
                            <path fill-rule="evenodd"
                                d="M9 2.221V7H4.221a2 2 0 0 1 .365-.5L8.5 2.586A2 2 0 0 1 9 2.22ZM11 2v5a2 2 0 0 1-2 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2 2 2 0 0 0 2 2h12a2 2 0 0 0 2-2 2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2V4a2 2 0 0 0-2-2h-7Zm1.018 8.828a2.34 2.34 0 0 0-2.373 2.13v.008a2.32 2.32 0 0 0 2.06 2.497l.535.059a.993.993 0 0 0 .136.006.272.272 0 0 1 .263.367l-.008.02a.377.377 0 0 1-.018.044.49.49 0 0 1-.078.02 1.689 1.689 0 0 1-.297.021h-1.13a1 1 0 1 0 0 2h1.13c.417 0 .892-.05 1.324-.279.47-.248.78-.648.953-1.134a2.272 2.272 0 0 0-2.115-3.06l-.478-.052a.32.32 0 0 1-.285-.341.34.34 0 0 1 .344-.306l.94.02a1 1 0 1 0 .043-2l-.943-.02h-.003Zm7.933 1.482a1 1 0 1 0-1.902-.62l-.57 1.747-.522-1.726a1 1 0 0 0-1.914.578l1.443 4.773a1 1 0 0 0 1.908.021l1.557-4.773Zm-13.762.88a.647.647 0 0 1 .458-.19h1.018a1 1 0 1 0 0-2H6.647A2.647 2.647 0 0 0 4 13.647v1.706A2.647 2.647 0 0 0 6.647 18h1.018a1 1 0 1 0 0-2H6.647A.647.647 0 0 1 6 15.353v-1.706c0-.172.068-.336.19-.457Z"
                                clip-rule="evenodd" />
                        </svg>
                        Export CSV
                    </button>
                    <t-dropdown>
                        <div slot="trigger" slot-scope="{ mousedownHandler, focusHandler, blurHandler, keydownHandler }"
                            class="flex">
                            <button
                                class="flex items-center justify-center h-10 px-3 py-2.5 text-gray-500 bg-white border border-gray-400 rounded-lg"
                                @mousedown="mousedownHandler" @focus="focusHandler" @blur="blurHandler"
                                @keydown="keydownHandler">
                                <svg class="w-4 h-4 mr-1 text-gray-600 dark:text-white" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                    viewBox="0 0 24 24">
                                    <path
                                        d="M5.05 3C3.291 3 2.352 5.024 3.51 6.317l5.422 6.059v4.874c0 .472.227.917.613 1.2l3.069 2.25c1.01.742 2.454.036 2.454-1.2v-7.124l5.422-6.059C21.647 5.024 20.708 3 18.95 3H5.05Z" />
                                </svg>
                                Filter
                                <svg class="w-5 h-5 ml-1 text-gray-600 fill-current" viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <polygon
                                        points="9.29289322 12.9497475 10 13.6568542 15.6568542 8 14.2426407 6.58578644 10 10.8284271 5.75735931 6.58578644 4.34314575 8" />
                                </svg>
                            </button>
                        </div>
                        <div class="w-custom bg-white absolute -right-2 pt-2 pb-3 border rounded-lg"
                            slot-scope="{ hide, blurHandler }">
                            <div class="block w-full px-4 py-2 text-sm text-gray-500 transition duration-150 ease-in-out focus:outline-none focus:bg-gray-100"
                                role="menuitem">
                                <div class="flex justify-between mb-0 mt-2">
                                    <div>
                                        <div class="mb-4">
                                        Filter
                                    </div>
                                        <h4 class="text-sm text-gray-800 ">
                                            Request Date</h4>
                                    </div>

                                    <div @click="hide">
                                        <svg class="w-4 h-4 text-gray-800 dark:text-white cursor-pointer"
                                            aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            fill="none" viewBox="0 0 24 24">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                                stroke-width="2" d="M6 18 17.94 6M18 18 6.06 6" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="grid gap-2 grid-cols-2">
                                    <div>
                                        <DatetimeCustom :timeDate="false" :label="'Start Date'" v-model="start_date"
                                            @blur="blurHandler"></DatetimeCustom>
                                    </div>
                                    <div>
                                        <DatetimeCustom :timeDate="false" :label="'End Date'" v-model="end_date"
                                            @blur="blurHandler"></DatetimeCustom>
                                    </div>
                                </div>
                                <div class="mt-3">
                                    <button class="border bg-blue-500 px-4 py-2 text-white rounded-lg"
                                        @click="filterRequestContent" @blur="blurHandler">
                                        Filter
                                    </button>
                                    <button class="border bg-white text-gray-500 px-4 py-2 rounded-lg ml-2"
                                        @click="actionReset()" @blur="blurHandler">Reset</button>
                                </div>
                            </div>
                        </div>
                    </t-dropdown>
                </div>
            </div>

            <div class="w-full">
                <TableRequestContent :currentpage="currentPage" :perpage="perPage" :data="item"
                    :isLoading="isLoading" />
            </div>

            <div v-if="totalRows / perPage > 1" class="flex justify-between ml-1 items-center mt-3">
                <div class="font-semibold">
                    <span class="text-gray-500 font-normal">Showing </span> {{ currentPage }}-{{ perPage }} <span
                        class="text-gray-500 font-normal">of</span> {{ parseInt(totalRows) }}
                </div>
                <div class="mb-2">
                    <t-pagination :total-items="Number(totalRows)" :per-page="perPage" v-model="currentPage"
                        class="rounded-lg" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import TableRequestContent from '../../components/request-content/table.vue';
import DatetimeCustom from '../../components/form/Datetime.vue'
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';

import moment from 'moment';
export default {
    name: "contentrequest",
    components: {
        TableRequestContent,
        DatetimeCustom,
        HeaderBreadcrumbs
    },
    computed: {
        ...mapState({
            //isError: (state) => state.coupons.isError,
            item: (state) => state.content.items,
            totalRows: (state) => state.content.totalRows,
            isLoading: (state) => state.content.isLoading,
            errorMessage: (state) => state.content.errorMessage,
            successMessage: (state) => state.content.successMessage,
        }),
    },
    data() {
        return {
            name: "",
            currentPage: 1,
            perPage: 15,
            description: "",
            client_name: "",
            debounceTimer: null,
            created: "",
            platforms: "",
            filter: null,
            price: '',
            status: '',
            start_date: moment()
                .startOf('month')
                .format('YYYY-MM-DD'),
            end_date: moment()
                .endOf('month')
                .format('YYYY-MM-DD'),
            showFullText: false,
            offer_name: "",
            modified: ""
        }
    },
    watch: {
        currentPage() {
            this.fetchDataRequestContent();
        },
    },
    mounted() {
        this.fetchDataRequestContent();
    },

    methods: {
        ...mapActions("content", [
            "RequestContent", "downloadCSV"
        ]),
        formatDate(tgl) {
            if (tgl) {
                return moment(tgl).format("DD MMMM YYYY HH:mm:ss");
            }
            return "-";
        },
        async fetchDataRequestContent() {
            const payload = this.buildPayload(this.currentPage);
            await this.RequestContent(payload);
        },

        async filterRequestContent() {
            this.currentPage = 1;
            const payload = this.buildPayload(this.currentPage);
            await this.RequestContent(payload);
        },


        buildPayload(page) {
            const payload = {
                page,
                limit: this.perPage,
                q: this.filter?.trim(),
            };

            if (this.start_date && this.end_date) {
                payload.start_period = moment(this.start_date).format('YYYY-MM-DD');
                payload.end_period = moment(this.end_date).format('YYYY-MM-DD');
            }

            return payload;
        },
        formatCurrency(amount, currency = "IDR") {
            const formatter = new Intl.NumberFormat("id-ID", { style: "currency", currency });
            return formatter.format(amount).replace(/\D00(?=\D*$)/, "");
        },
        actionReset() {
            window.location.reload()
        },
        async btndownloadCSV() {
            this.downloadCSV()
        },

    }
}

</script>
<style scoped>
.w-custom {
    width: 550px;
}
</style>
